// extracted by mini-css-extract-plugin
export default {"container":"historyBanner_container__ftTpI","image":"historyBanner_image__zSSOg"};